import { createSlice } from "@reduxjs/toolkit";

interface CommunityState {
  community_select_brand_number: number;
  community_select_product_type_number: number;
  community_select_page: number;
  community_select_search_text: string;
  community_select_sort_number: number;
};

const initialState = {
  community_select_brand_number: 0,
  community_select_product_type_number: 0,
  community_select_page: 1,
  community_select_search_text: "",
  community_select_sort_number: 0,
} as CommunityState;

const CommunitySlice = createSlice({
  name: 'community_data',
  initialState,
  reducers: {
    reduxChangeCommunitySelectBrandNumber : (state, action) => {
      state.community_select_brand_number = action.payload;
    },
    reduxChangeCommunitySelectProductTypeNumber : (state, action) => {
      state.community_select_product_type_number = action.payload;
    },
    reduxChangeCommunitySelectPage : (state, action) => {
      state.community_select_page = action.payload;
    },
    reduxChangeCommunitySelectSearchText : (state, action) => {
      state.community_select_search_text = action.payload;
    },
    reduxChangeCommunitySelectSortNumber : (state, action) => {
      state.community_select_sort_number = action.payload;
    },
    reduxResetCommunity : (state) => {
      Object.assign(state, initialState);
    },
  }
});

export const {
  reduxChangeCommunitySelectBrandNumber,
  reduxChangeCommunitySelectProductTypeNumber,
  reduxChangeCommunitySelectPage,
  reduxChangeCommunitySelectSearchText,
  reduxChangeCommunitySelectSortNumber,
  reduxResetCommunity,
} = CommunitySlice.actions;

export default CommunitySlice.reducer;